import { FC, ReactNode } from "react";
import { DialogModal } from "@/components/Modal";

export const InteractiveTableDialog: FC<{
  children?: ReactNode;
  closeDialog: () => void;
  isOpen: boolean;
  headline: string;
  content?: string;
}> = ({ children, isOpen, closeDialog, headline, content }) => (
  <DialogModal open={isOpen} onClose={closeDialog} panelClassName="!max-w-152">
    <div className="border-b-swdc-silver-200 text-subhead-m text-swdc-black-600 border-b-2 pb-6 font-bold">
      {headline}
    </div>
    {content && (
      <div
        className="text-body-m text-swdc-gray-400 [&_li]:display-list-item [&_li]:marker:text-swdc-orange-400 [&_ol]:marker:text-swdc-gray-400 pt-6 [&_li]:pb-3 [&_li]:last:pb-0 [&_ol]:ml-6 [&_ol]:list-decimal [&_p]:mb-4 [&_p]:last:mb-0 [&_strong]:font-bold [&_ul]:ml-4 [&_ul]:list-outside [&_ul]:list-disc"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )}
    {children}
  </DialogModal>
);
